"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Text.css");
/**
 * @see TextProps
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text(props) {
        return _super.call(this, props) || this;
    }
    Text.prototype.render = function () {
        var _a = this.props, text = _a.text, toolTip = _a.toolTip, size = _a.size, color = _a.color, decoration = _a.decoration, weight = _a.weight, mode = _a.mode, wrapMode = _a.wrapMode, id = _a.id;
        var cssClasses = generateClasses();
        function generateClasses() {
            var cssClassList = ['p-text'];
            cssClassList.push(constructClass(size, 'p-f-sz'));
            cssClassList.push(constructClass(color, 'p-t'));
            cssClassList.push(constructClass(decoration, 'p'));
            cssClassList.push(constructClass(weight, 'p-f-w'));
            if (wrapMode === 'Ellipsis') {
                cssClassList.push('p-t-wr-el');
            }
            else if (wrapMode === 'ForcedWrap' || text.indexOf(' ') < 0) {
                cssClassList.push('p-t-wr-fw');
            }
            return cssClassList.join(' ');
        }
        var attrs = {};
        if (this.props.tag != null)
            attrs['data-tag'] = this.props.tag;
        function customizeEnums(en) {
            var cases = {
                Xsmall: 'xs',
                Small: 'sm',
                Medium: 'md',
                Large: 'lg',
                Xlarge: 'xl',
                Xlarge2: '2x',
                Xlarge3: '3x',
                Xlarge4: '4x',
                Xlarge5: '5x',
                Primary: 'Primary50',
                Secondary: 'Secondary50',
                Success: 'Success50',
                Warning: 'Warning50',
                Error: 'Error50',
                Info: 'Info50',
                Capitalize: 't-t-c',
                Lowercase: 't-t-l',
                Uppercase: 't-t-u',
                Strikethrough: 't-d-lt',
                Underline: 't-d-ul',
                Italic: 'f-st-i',
                Normal: 'n',
                Bold: 'b',
                SemiBold: '6'
            };
            return cases[en] ? cases[en].toLowerCase() : en.toLowerCase();
        }
        function constructClass(prop, prefix) {
            if (prop && prop !== 'None') {
                var customProp = customizeEnums(prop);
                return prefix + "-" + customProp;
            }
            return '';
        }
        return mode === 'Inline' ? (React.createElement("span", __assign({ id: id, className: cssClasses, title: toolTip }, attrs), text)) : (React.createElement("p", __assign({ id: id, className: cssClasses, title: toolTip }, attrs), text));
    };
    Text.defaultProps = {
        text: '',
        size: 'Medium',
        color: 'Default',
        decoration: 'None',
        weight: 'Normal',
        mode: 'Inline',
        wrapMode: 'None'
    };
    return Text;
}(React.PureComponent));
exports.Text = Text;
exports.default = Text;
//# sourceMappingURL=Text.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/text/build/control/Text.js
// module id = 710
// module chunks = 0